<template>
  <a class="show-wrapper" @click="clickHandler">
    <p class="paragraph-s">{{ moreLessLabel }}</p>
    <svg-icon :name="iconName" width="12" height="12"></svg-icon>
  </a>
</template>

<script>

import '../distribution/icons/arrow-show-less';
import '../distribution/icons/arrow-show-more';

export default {
  data() {
    return {
      isShowMoreOn: false
    };
  },
  computed: {
    moreLessLabel() {
      return this.isShowMoreOn ? this.$gettext('Show less') : this.$gettext('Show more');
    },
    iconName() {
      return this.isShowMoreOn ? 'arrow-show-less' : 'arrow-show-more';
    }
  },
  methods: {
    toggleShow() {
      this.isShowMoreOn = !this.isShowMoreOn;
    },
    clickHandler() {
      this.toggleShow();
      this.$emit(this.isShowMoreOn ? 'show-more' : 'show-less');
    }
  }
};
</script>

<style lang="scss" scoped>
.show-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 7px 0;

  p {
    color: var(--dark-gray);
    opacity: 0.6;
  }

  svg {
    margin-top: 3px;
  }
}
</style>
